module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAA9ElEQVQ4jaXRvy6FQRQE8N8ujU4kohO9iKhR6RS3p5V4h+10G7UaheKWgmdQCo0nEOJfIirdrkiQ68v9PldMdbKTmTM7JxhAzXECG+hhGV98xTlO0Q+pvH2pxv3EJnbxivsGt4CVz/mgzSDiJKSyZQhqjvsYawr+hV8Nao6LNceZNr7ToOY4hcOQysOfDWqOHxc4xm3XkmaJg9jDKi5rjmcYWuzQBDXHacziGvO4CKk8jmwQUnkKqfQ++aOQyk5bzK4OlnCH7Y5vdl7hBushldpl0FpiSOW5SzhKgpEwLMFkzXGuRT3ZfGgavGANVx3r+98T3gFeHDodxMrTYwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/subDevice/son_icon_electricity.png
// module id = 1aC3
// module chunks = 4